import { Autocomplete, Box, IconButton, MenuItem, Select, Skeleton, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import '../UmaDocNotes.css';
import { COMMON_STYLE, NEW_DOC_DURATION_LIST, NEW_DOC_EYE_TYPE } from '../../../../Utility/Constants';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent';
import { useDebounce } from '../../../../Components/Common Components/CommonComponents';
import DeleteIcon from '@mui/icons-material/Delete';
import { clearCachevalue, getCachevalue, setCachevalue } from '../../../../Utility/Services/CacheProviderService';

const UmaDocComplaints = React.forwardRef((data, ref) => {
    const listVal = data
    const [complaints, setComplaints] = useState({
        durationList: NEW_DOC_DURATION_LIST,
        eyeList: NEW_DOC_EYE_TYPE,
        complaintsuggestion: [],
        complaintDescription: '',
        complaintData: [],
        dupComplaintData: '[]',
        dupComplaintDesp: '',
        loadScreen: false
    })
    const [search, setSearch] = useState('')
    const debouneQuery = useDebounce(search, 500)

    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: `${message} - COMPLAINTS`,
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: `${message} - COMPLAINTS`,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    React.useImperativeHandle(ref, () => ({
        performComplaintsAction: () => {
            let complaintData = JSON.stringify(complaints.complaintData)
            if (complaintData !== complaints.dupComplaintData || JSON.stringify(complaints.complaintDescription) !== complaints.dupComplaintDesp) {
                postComplaintData()
            }
        }
    }))

    const apiCalls = async () => {
        await getComplaintsData()
    }

    useEffect(() => {
        if (debouneQuery) {
            getComplaintSuggestionList(debouneQuery)
        } else {
            setComplaints((prev) => ({ ...prev, complaintsuggestion: [] }))
        }
    }, [debouneQuery])

    const getComplaintSuggestionList = async (searchQuery) => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_COMPLAINTS_SUGG + '?search_key=' + searchQuery + '&doctor_id=' + data?.props?.doctorID)
            if (response.data.status === 'success') {
                setComplaints((prev) => ({ ...prev, complaintsuggestion: response.data.data }))
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const getComplaintsData = async () => {
        try {
            const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_COMPLAINTS +
                '?appointment_id=' + data?.props.appointment_id + '&patient_id=' + data?.props.patient_id + '&doctor_id=' + data?.props?.doctorID)
            if (response.data.status === 'success') {
                let data = response.data.data?.data
                let obj = { complaints: '', complaint_description: '', duration_type: '1', duration_time: '' }
                setComplaints((prev) => ({
                    ...prev,
                    complaintData: data?.length > 0 ? [...data, obj] : [obj],
                    complaintDescription: response.data.data?.complaint_description,
                    dupComplaintData: data?.length > 0 ? JSON.stringify([...data, obj]) : JSON.stringify([obj]),
                    dupComplaintDesp: JSON.stringify(response.data.data?.complaint_description),
                    loadScreen: true
                }))
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response.data.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const postComplaintData = async () => {
        try {
            let complaintList = complaints.complaintData?.filter(item => item?.complaint_description);
            let list = {
                appointment_id: data?.props.appointment_id,
                complaint_description: complaints.complaintDescription,
                data: complaintList,
                doctor_id: data?.props?.doctorID
            }
            const response = await RestAPIService.create(list, Serviceurls.NEW_DOC_NOTES_COMPLAINTS)
            if (response.data.status === 'success') {
                successMessage(response.data.message)
                await getComplaintsData()
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response?.data?.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const deleteComplaintsData = async (item, index) => {
        try {
            if (item?.id) {
                let data = { id: item?.id, doctor_id: listVal?.props?.doctorID }
                const response = await RestAPIService.delete(Serviceurls.NEW_DOC_NOTES_COMPLAINTS, data)
                if (response.data.status === 'success') {
                    successMessage(response.data.message)
                    await getComplaintsData()
                }
            } else {
                let complaintData = [...complaints.complaintData]
                setComplaints((prev) => {
                    if (index !== (complaints.complaintData?.length - 1)) {
                        complaintData?.splice(index, 1)
                    } else {
                        complaintData[index] = { complaints: null, complaint_description: '', duration_type: '1', duration_time: '' }
                    }
                    return { ...prev, complaintData }
                })
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                errorMessage(error.response?.data?.message)
            } else {
                errorMessage(error.message)
            }
        }
    }

    const onChangeHandler = (newValue, key, index) => {
        try {
            setComplaints((prev) => {
                const complaintData = [...prev.complaintData]
                switch (key) {
                    case 'duration_time':
                        if (CommonValidation.numberOnly(newValue) && (+newValue <= 31) || newValue === '') {
                            complaintData[index] = { ...complaintData[index], duration_time: newValue }
                        }
                        break;
                    case 'complaint_description':
                        complaintData[index] = { ...complaintData[index], complaint_description: newValue };
                        if (newValue !== '' && index === complaintData.length - 1) {
                            let obj = { complaints: null, complaint_description: '', duration_type: '1', duration_time: '' };
                            complaintData?.push(obj)
                        }
                        break;
                    default:
                        complaintData[index] = { ...complaintData[index], [key]: newValue }
                        break;
                }
                return { ...prev, complaintData, complaintsuggestion: [] }
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    return (
        <ShowComponents onIntersection={apiCalls}>
            <Box component={'div'}>
                <Box component={'div'}>
                    <Box component={'div'} className='doc_notes_header_card'>
                        <Typography className='doc_notes_header_card_font'>Complaints</Typography>
                    </Box>
                    <Box component={'div'} p={'0.5rem'}>
                        <TextField size='small' fullWidth label='Complaints Description' multiline maxRows={5}
                            value={complaints.complaintDescription}
                            disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                            onChange={(e) => {
                                let value = e.target.value
                                if (value?.length <= COMMON_STYLE.CHAR_LIMIT_DESP || value === '') {
                                    setComplaints((prev) => ({ ...prev, complaintDescription: value }))
                                }
                            }}
                            InputProps={{ emed_tid: 'com_desp' }}
                        />
                        <Box component={'div'} mt={'0.5rem'} border={'1px solid lightgray'}>
                            <Table size='small'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                                        <TableCell className='doc_notes_tbl_header'>Complaints</TableCell>
                                        <TableCell className='doc_notes_tbl_header'>Duration</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {complaints?.complaintData?.length > 0 ? complaints?.complaintData?.map((item, index) => {
                                        return (
                                            <TableRow key={index}>
                                                <TableCell className='doc_notes_tbl_body_cell'>
                                                    <Select
                                                        size="small"
                                                        sx={{ width: '8dvw', height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }}
                                                        value={item?.complaints || ''}
                                                        onChange={(e) => onChangeHandler(e.target.value, 'complaints', index)}
                                                        inputProps={{ emed_tid: 'comp_eye' }}
                                                        displayEmpty
                                                        disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                                                    >
                                                        <MenuItem value="" disabled>Select Eye</MenuItem>
                                                        {complaints.eyeList.map((option, idx) => (
                                                            <MenuItem key={idx} value={option?.value}>{option?.label}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </TableCell>
                                                <TableCell className='doc_notes_tbl_body_cell'>
                                                    <Autocomplete
                                                        disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                                                        clearIcon
                                                        freeSolo
                                                        size='small'
                                                        sx={{ width: '13dvw' }}
                                                        value={item?.complaint_description}
                                                        options={complaints.complaintsuggestion}
                                                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option}
                                                        onChange={(e, newValue) => {
                                                            onChangeHandler(newValue, 'complaint_description', index)
                                                        }}
                                                        onInputChange={(e, newValue) => {
                                                            onChangeHandler(newValue, 'complaint_description', index)
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder='Enter Complaints *'
                                                                InputProps={{
                                                                    ...params.InputProps, emed_tid: 'comp_tbl_desp',
                                                                    style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                                                                }}
                                                                onChange={(e) => {
                                                                    let value = e.target.value
                                                                    setSearch(value)
                                                                    onChangeHandler(value, 'complaint_description', index)
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </TableCell>
                                                <TableCell className='doc_notes_tbl_body_cell'>
                                                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                                                        <TextField
                                                            disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                                                            autoComplete='off'
                                                            size='small'
                                                            sx={{ width: '5dvw' }}
                                                            InputProps={{
                                                                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING },
                                                                emed_tid: 'comp_dur_time'
                                                            }}
                                                            value={item?.duration_time}
                                                            onChange={(e) => {
                                                                let value = e.target.value
                                                                onChangeHandler(value, 'duration_time', index)
                                                            }} />
                                                        <Select
                                                            size="small"
                                                            sx={{ width: '6dvw', height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }}
                                                            value={item?.duration_type || ''}
                                                            onChange={(e) => onChangeHandler(e.target.value, 'duration_type', index)}
                                                            inputProps={{ emed_tid: 'comp_dur_type' }}
                                                            displayEmpty
                                                            disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                                                        >
                                                            <MenuItem value="" disabled>Select Duration</MenuItem>
                                                            {complaints.durationList.map((option, idx) => (
                                                                <MenuItem key={idx} value={option?.value}>{option?.label}</MenuItem>
                                                            ))}
                                                        </Select>
                                                        <IconButton sx={{ height: COMMON_STYLE.HEIGHT }} emed_tid='comp_dlt'
                                                            disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                                                            onClick={() => { deleteComplaintsData(item, index) }}
                                                        ><DeleteIcon color={data?.props?.patient_transfered || data?.props?.isLocked ? '' : 'error'} /></IconButton>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }) : <TableRow><TableCell align='center' colSpan={3}>No Records To Be Shown</TableCell></TableRow>}
                                </TableBody>
                            </Table>
                        </Box>
                    </Box>
                </Box>
                {message.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={message.isErrorMsgText}
                        msgPop={msgClose}
                    />
                    : null}
                {message.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={message.successMsgText}
                        msgPop={msgClose}
                    />
                    : null}
            </Box>
        </ShowComponents>
    )
})

export default UmaDocComplaints